module.exports = "dist/spain.png?5730650e307fbe2247a7fdcf234f5afa";